import { useEffect, useSyncExternalStore } from "react";

/**
 * Pages outside a service's own addresses (an engagement, for example) name the menu
 * item they belong to, so the sidebar keeps the service highlighted.
 */
let hint: string | null = null;
const listeners = new Set<() => void>();

export function useNavHint(): string | null {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => hint,
  );
}

export function useSetNavHint(href: string | null) {
  useEffect(() => {
    hint = href;
    listeners.forEach((l) => l());
    return () => {
      hint = null;
      listeners.forEach((l) => l());
    };
  }, [href]);
}
